/**
 * @file store/locales.ts
 * @description 国际化状态管理模块，管理应用的语言设置和时区配置
 */

import { defineStore } from 'pinia'
import { ref } from 'vue'
import { i18n } from '../locales/index'

/**
 * 语言状态 Store
 * @description 管理应用的语言设置，支持动态加载翻译文本
 */
export const useLocaleStore = defineStore(
  'locale',
  () => {
    // 从 localStorage 获取用户语言设置，默认使用 i18n 的默认语言
    const userLocale = localStorage.getItem('user-locale') ? JSON.parse(localStorage.getItem('user-locale')).overseaCode : ''
    const locale = ref(userLocale || i18n.global.locale.value);

    const translateMapper = ref({
      en_US: {},
      zh_CN: {},
    })

    /**
     * 获取翻译映射值
     * @param key
     */
    function getTranslate(key: string) {
      return translateMapper.value?.[locale.value]?.[key] || key
    }

    // 已加载翻译的语言集合，防止重复加载
    const transLocaleSet = new Set(['en_US', 'zh_CN'])

    /**
     * 设置当前语言
     * @param lang - 语言编码（如 'zh_CN', 'en_US'）
     */
    function setLocale(lang: any) {
      locale.value = lang
      i18n.global.locale.value = lang
    }
    return { locale, setLocale, translateMapper, getTranslate }
  }
)

/**
 * 时区状态 Store
 * @description 管理用户时区配置，用于时间显示的转换计算
 */
export const useTimeZoneStore = defineStore(
  'timeZone',
  {
    /**
     * 状态定义
     * @property userTimeZone - 用户时区名称
     * @property userTimeZoneDiffToSystemSecond - 用户时区与系统时区的差值（秒）
     * @property userTimeZoneDiffToZeroSecond - 用户时区与 UTC 的差值（秒）
     */
    state: () => ({
      userTimeZone: "America/Merida", // 默认时区
      userTimeZoneDiffToSystemSecond: -50400, // 与系统时区差值
      userTimeZoneDiffToZeroSecond: -21600 // 与 UTC 差值
    })
  }
)

